const VISIT_KEY_PREFIX = 'cryllex_payment_seen_';

export const getPaymentVisitKey = (token) => `${VISIT_KEY_PREFIX}${token}`;

/** True after user refreshed or reopened this payment URL (not the first load). */
export const isPaymentReturnVisit = (token) => {
  if (!token) return false;
  return localStorage.getItem(getPaymentVisitKey(token)) === '1';
};

export const markPaymentSeen = (token) => {
  if (!token) return;
  localStorage.setItem(getPaymentVisitKey(token), '1');
};

/** Reset so return to this payment URL is treated as first visit (no wallet auto-reconnect). */
export const resetPaymentAutoReconnect = (token) => {
  if (!token) return;
  localStorage.removeItem(getPaymentVisitKey(token));
};

export const redirectToMerchant = (token, url) => {
  resetPaymentAutoReconnect(token);
  if (url) {
    window.location.replace(url);
  }
};

/** Call on first visit so refresh / tab reopen enables wallet auto-reconnect. */
export const registerPaymentSeenOnLeave = (token) => {
  if (!token || isPaymentReturnVisit(token)) return () => {};

  const markSeen = () => markPaymentSeen(token);

  window.addEventListener('pagehide', markSeen);
  return () => window.removeEventListener('pagehide', markSeen);
};
